/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListK12DistrictsQueryResponse,
  ListK12DistrictsQueryParams,
} from '../types/ListK12Districts'

function getListK12DistrictsUrl() {
  const res = { method: 'GET', url: `/api/v1/k12/districts/` as const }
  return res
}

/**
 * @summary List K-12 districts
 * {@link /api/v1/k12/districts/}
 */
export async function listK12Districts(
  params?: ListK12DistrictsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListK12DistrictsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListK12DistrictsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
